<template>
  <verte picker="square" model="hex" @input="inputChanged" :value="defaultColor" :menuPosition="menuPosition">
    <svg
      viewBox="64 64 896 896"
      data-icon="bg-colors"
      width="1em"
      height="1em"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
      class=""
    >
      <path
        d="M850.286 434.968c-14.003-29.861-30.933-57.319-50.124-82.347a3284.025 3284.025 0 0 1-40.587 36.24C705.338 436.52 627.15 507.197 623.32 516.734c-3.83 9.537-26.659 93.355-154.625 126.41-29.575 5.836-74.79 40.094-84.135 31.648-20.087-13.09 0.727-98.89 17.553-135.743 16.819-36.849 55.624-99.704 87.148-104.909 31.526-5.207 113.814-78.414 175.966-133.029 14.946-13.131 29.694-25.883 44.179-38.16-138.566-104.44-321.71-127.637-426.114-63.315-147.83 91.072-162.249 304.744-32.21 477.25C381.12 849.393 639.05 912.653 790.79 822.433c33.79-18.594-39.831-142.378-39.668-200.21 0.168-57.832 125.976-132.14 99.163-187.254zM482.39 205.7c38.809 0 70.271 28.443 70.271 63.527 0 35.085-31.462 63.528-70.271 63.528s-70.271-28.443-70.271-63.528c0-35.084 31.462-63.527 70.271-63.527zM275.814 475.843c-38.808 0-70.27-28.443-70.27-63.528s31.462-63.528 70.27-63.528c38.81 0 70.273 28.442 70.273 63.528s-31.463 63.528-70.273 63.528z m363.06 332.002c-38.811 0-70.267-28.445-70.267-63.525 0-35.087 31.456-63.531 70.267-63.531 38.812 0 70.278 28.444 70.278 63.531 0 35.08-31.466 63.525-70.278 63.525zM607.824 462.454l-19.463-17.095c-10.69-9.38-27.437-8.761-37.24 1.374 0 0-12.171 12.59-23.447 28.179-6.67-0.488-14.144 0.013-22.495 1.924-51.069 11.687-68.96 61.017-68.96 61.017s-25.015 81.507-11.663 90.21c6.21 5.614 28.873-24.164 48.529-28.041 96.483-24.923 105.172-65.943 103.675-84.466 16.838-9.762 30.004-20.05 30.004-20.05 11.267-8.8 11.745-23.674 1.06-33.052zM859.223 216.343c-21.038-19.015-158.209 83.589-252.45 166.406a41546.377 41546.377 0 0 1-14.223 12.49c-10.689 9.365-10.7 24.7-0.025 34.077l25.928 22.763c10.678 9.377 28.08 9.313 38.675-0.146 0 0 1.48-1.323 12.346-10.87 94.246-82.814 211.21-205.319 189.749-224.72z"
        p-id="1722"
      ></path>
    </svg>
    <!-- <svg
      viewBox="64 64 896 896"
      data-icon="bg-colors"
      width="1em"
      height="1em"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
      class=""
    >
      <path
        d="M766.4 744.3c43.7 0 79.4-36.2 79.4-80.5 0-53.5-79.4-140.8-79.4-140.8S687 610.3 687 663.8c0 44.3 35.7 80.5 79.4 80.5zm-377.1-44.1c7.1 7.1 18.6 7.1 25.6 0l256.1-256c7.1-7.1 7.1-18.6 0-25.6l-256-256c-.6-.6-1.3-1.2-2-1.7l-78.2-78.2a9.11 9.11 0 0 0-12.8 0l-48 48a9.11 9.11 0 0 0 0 12.8l67.2 67.2-207.8 207.9c-7.1 7.1-7.1 18.6 0 25.6l255.9 256zm12.9-448.6l178.9 178.9H223.4l178.8-178.9zM904 816H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8z"
      ></path>
    </svg> -->
  </verte>
</template>

<script>
import Verte from 'verte'
import 'verte/dist/verte.css'

export default {
  name: 'JInputColor',
  components: { Verte },
  props: {
    // API:https://baianat.github.io/verte/api.html#props
    // the initial color value
    defaultColor: {
      type: String,
      default: '#52c41a'
    },
    // menu position
    // 'top' | 'bottom' | 'left' | 'right' | 'center'
    menuPosition: {
      type: String,
      default: 'top'
    }
  },
  data() {
    return {}
  },
  watch: {},
  computed: {},
  created() {
    if (!this.value) {
      this.value = '#52c41a'
    }
  },
  methods: {
    inputChanged(e) {
      // v-model
      this.$emit('input', e)
      // v-decorator
      this.$emit('change', e)
    }
  }
}
</script>

<style lang="less" scoped>
.verte {
  justify-content: unset;
  padding: 4px 0;
  position: absolute;
  top: -6px;
  left: 5px;
}

/deep/.verte__guide {
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0px solid;
  background: transparent;
  padding: 3px;
  border-radius: 50%;
  vertical-align: middle;
  line-height: 0;
  cursor: pointer;
  transform: rotate(0deg) scale(1.3);
}

/deep/.verte__guide:hover {
  // animation: loadingCircle 2s linear infinite;
}

/deep/ .verte__draggable {
  border-radius: 0px;
}
</style>
